/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { ElCalendarComponent } from './calendar.component';
import { ElBaseCalendarModule } from './base-calendar.module';


@NgModule({
  imports: [ElBaseCalendarModule],
  exports: [ElCalendarComponent],
  declarations: [ElCalendarComponent],
})
export class ElCalendarModule {
}
